<template>
    <c-dialog ref="dialog" width="750" mode="slide" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-form-item label="版本名称" required>
                <c-input name="version_name" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="版本ICON" required tip="建议尺寸50*50像素">
                <c-upload-file name="icon_img_url" type="image" size="1024" button="请选择图片" media></c-upload-file>
            </c-form-item>
            <c-form-item label="版本背景图" required  tip="建议尺寸480*50像素">
                <c-upload-file name="background_img_url" type="image" size="1024" button="请选择图片" media></c-upload-file>
            </c-form-item>
            <c-form-item label="版本说明">
                <c-input type="textarea" name="version_desc"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            editState: false
        }
    },
    computed: {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.editState = !!data;
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: this.editState ? '编辑版本信息' : '创建版本信息'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this.editState ? '/sys_saas/version/edit' : '/sys_saas/version/add',
                rule: {
                    version_name: '请输入版本名称',
                    icon_img_url: '请上传版本ICON图片',
                    background_img_url: '请上传版本背景图图片'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>